import { useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/LegsEditor";
import { useApi, errMsg } from "@/lib/api";

export default function AcknowledgeDialog({ trip, open, onOpenChange, onSaved }) {
  const api = useApi();
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  const send = async () => {
    setSaving(true);
    try {
      await api.post(`/trips/${trip.id}/acknowledge`, { note });
      toast.success(`${trip.broker_name || "The broker"} has been notified that the request is being worked on.`);
      onOpenChange(false);
      setNote("");
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-white/10 max-w-lg w-[calc(100%-2rem)] grid-cols-[minmax(0,1fr)]" data-testid="acknowledge-dialog">
        <DialogHeader>
          <p className="eyebrow">{trip.ref}</p>
          <DialogTitle className="font-serif-display text-3xl font-normal text-white">Acknowledge request</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-zinc-400">
          {trip.broker_name || "The broker"} will get an email and an in-app alert: “We've received your trip request. Our flight department is working on it and will provide options shortly.”
        </p>
        <Field label="Add a note (optional)">
          <Textarea className="bg-[#0d0f14] border-white/10 min-h-[100px]" value={note} maxLength={1000} onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. Expect options within the next 2 hours." data-testid="acknowledge-note-input" />
        </Field>
        <div className="flex flex-wrap justify-end gap-3 pt-2">
          <button type="button" className="frame-btn" onClick={() => onOpenChange(false)} data-testid="acknowledge-cancel-btn">Cancel</button>
          <button type="button" className="frame-btn gold" disabled={saving} onClick={send} data-testid="acknowledge-send-btn">
            <MailCheck size={13} /> {saving ? "Sending…" : "Send acknowledgment"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
